import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getSeniormaster=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_SENIOR_MASTER_START
    })
    const options={
        url:`${api}/smasters`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_SENIOR_MASTER_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_SENIOR_MASTER_FAIL,
                payload:getMessage(error)
            }))
}